import { createSlice } from "@reduxjs/toolkit";
import { fetchPracticeLocationDetails } from "./PracticeLocationAction";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const practiceLocationDetails = createSlice({
  name: "practiceLocationDetails",
  initialState: {
    isLoading: false,
    practiceLocationData: [],
    practiceLocationError: "",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPracticeLocationDetails.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchPracticeLocationDetails.fulfilled, (state, action) => {
        state.isLoading = false;
        if(!action.payload.success){
          state.isLoading = true;
          state.practiceLocationData = [];
          state.practiceLocationError = getApiErrorMessage(action.payload.status);
        } else {
          state.isLoading = false;
          state.practiceLocationData = action.payload.data.data.practiceNameAddressResponseDTO;
        } 
      })
      .addCase(fetchPracticeLocationDetails.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message;
      });
  },
});
export const practiceLocationReducer = practiceLocationDetails.reducer;